// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MeChangeNameRequest,
    MeInfoResponse,
    MePersonalTwoFactorRequest,
    MePersonalTwoFactorVerificationRequest,
    MeTwoFactorResponse,
    ObjectNoResponse,
    ResetPasswordUrl,
    TemporaryUrl,
    MeChangeNameRequestToJSON,
    MePersonalTwoFactorRequestToJSON,
    MePersonalTwoFactorVerificationRequestToJSON,
    MeInfoResponseFromJSON,
    MeTwoFactorResponseFromJSON,
    ObjectNoResponseFromJSON,
    ResetPasswordUrlFromJSON,
    TemporaryUrlFromJSON,
} from '../models';

export interface MePostPersonalInfoNameRequest {
    meChangeNameRequest: MeChangeNameRequest;
}

export interface MePostPersonalTwoFactorPreferenceRequest {
    mePersonalTwoFactorRequest: MePersonalTwoFactorRequest;
}

export interface MePostPersonalTwoFactorPreferenceVerificationVerificationRequest {
    mePersonalTwoFactorVerificationRequest: MePersonalTwoFactorVerificationRequest;
}

export interface PostAppUiSessionRequest {
    id: string;
}

/**
 * no description
 */
export class MeApi extends runtime.BaseAPI {

    /**
     * Resets 2fa devices
     * Resets 2fa devices
     */
    async auth2faResetRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/personal/2fa/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Resets 2fa devices
     * Resets 2fa devices
     */
    async auth2faReset(): Promise<ObjectNoResponse> {
        const response = await this.auth2faResetRaw();
        return await response.value();
    }

    /**
     * Create a password reset url
     * Create a password reset URL
     */
    async authPasswordResetUrlRaw(): Promise<runtime.ApiResponse<ResetPasswordUrl>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/personal/password/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPasswordUrlFromJSON(jsonValue));
    }

    /**
     * Create a password reset url
     * Create a password reset URL
     */
    async authPasswordResetUrl(): Promise<ResetPasswordUrl> {
        const response = await this.authPasswordResetUrlRaw();
        return await response.value();
    }

    /**
     * Get information about logged in user
     * Get information about logged in user
     */
    async getMeInfoRaw(): Promise<runtime.ApiResponse<MeInfoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MeInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get information about logged in user
     * Get information about logged in user
     */
    async getMeInfo(): Promise<MeInfoResponse> {
        const response = await this.getMeInfoRaw();
        return await response.value();
    }

    /**
     * Change personal name
     * Change personal name
     */
    async mePostPersonalInfoNameRaw(requestParameters: MePostPersonalInfoNameRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['meChangeNameRequest'] === null || requestParameters['meChangeNameRequest'] === undefined) {
            throw new runtime.RequiredError('meChangeNameRequest','Required parameter requestParameters.meChangeNameRequest was null or undefined when calling mePostPersonalInfoName.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/personal/name`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeChangeNameRequestToJSON(requestParameters['meChangeNameRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Change personal name
     * Change personal name
     */
    async mePostPersonalInfoName(requestParameters: MePostPersonalInfoNameRequest): Promise<ObjectNoResponse> {
        const response = await this.mePostPersonalInfoNameRaw(requestParameters);
        return await response.value();
    }

    /**
     * Change two factor preference
     * Change two factor preference
     */
    async mePostPersonalTwoFactorPreferenceRaw(requestParameters: MePostPersonalTwoFactorPreferenceRequest): Promise<runtime.ApiResponse<MeTwoFactorResponse>> {
        if (requestParameters['mePersonalTwoFactorRequest'] === null || requestParameters['mePersonalTwoFactorRequest'] === undefined) {
            throw new runtime.RequiredError('mePersonalTwoFactorRequest','Required parameter requestParameters.mePersonalTwoFactorRequest was null or undefined when calling mePostPersonalTwoFactorPreference.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/personal/two_factor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MePersonalTwoFactorRequestToJSON(requestParameters['mePersonalTwoFactorRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MeTwoFactorResponseFromJSON(jsonValue));
    }

    /**
     * Change two factor preference
     * Change two factor preference
     */
    async mePostPersonalTwoFactorPreference(requestParameters: MePostPersonalTwoFactorPreferenceRequest): Promise<MeTwoFactorResponse> {
        const response = await this.mePostPersonalTwoFactorPreferenceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Change two factor preference (verification)
     * Change two factor preference (verification)
     */
    async mePostPersonalTwoFactorPreferenceVerificationVerificationRaw(requestParameters: MePostPersonalTwoFactorPreferenceVerificationVerificationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['mePersonalTwoFactorVerificationRequest'] === null || requestParameters['mePersonalTwoFactorVerificationRequest'] === undefined) {
            throw new runtime.RequiredError('mePersonalTwoFactorVerificationRequest','Required parameter requestParameters.mePersonalTwoFactorVerificationRequest was null or undefined when calling mePostPersonalTwoFactorPreferenceVerificationVerification.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/personal/two_factor_verification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MePersonalTwoFactorVerificationRequestToJSON(requestParameters['mePersonalTwoFactorVerificationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Change two factor preference (verification)
     * Change two factor preference (verification)
     */
    async mePostPersonalTwoFactorPreferenceVerificationVerification(requestParameters: MePostPersonalTwoFactorPreferenceVerificationVerificationRequest): Promise<ObjectNoResponse> {
        const response = await this.mePostPersonalTwoFactorPreferenceVerificationVerificationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a UI session (with a provided app id)
     * Create a UI session (with a provided app id)
     */
    async postAppUiSessionRaw(requestParameters: PostAppUiSessionRequest): Promise<runtime.ApiResponse<TemporaryUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postAppUiSession.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/ui_session/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryUrlFromJSON(jsonValue));
    }

    /**
     * Create a UI session (with a provided app id)
     * Create a UI session (with a provided app id)
     */
    async postAppUiSession(requestParameters: PostAppUiSessionRequest): Promise<TemporaryUrl> {
        const response = await this.postAppUiSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a UI session
     * Create a UI session
     */
    async postUiSessionRaw(): Promise<runtime.ApiResponse<TemporaryUrl>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/ui_session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryUrlFromJSON(jsonValue));
    }

    /**
     * Create a UI session
     * Create a UI session
     */
    async postUiSession(): Promise<TemporaryUrl> {
        const response = await this.postUiSessionRaw();
        return await response.value();
    }

}
